import React from 'react';
import { Hero } from './Hero';
import { Story } from './Story';
import { Quotes } from './Quotes';
import { BookDetails } from './BookDetails';
import { SpecialOffer } from './SpecialOffer';
import { Footer } from './Footer';
export const BookPromo = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-37">
      <Hero data-id="element-38" />
      <Story data-id="element-39" />
      <Quotes data-id="element-40" />
      <BookDetails data-id="element-41" />
      <SpecialOffer data-id="element-42" />
      <Footer data-id="element-43" />
    </div>;
};